var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuIcSccRoad = function SvgMenuIcSccRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.89 0h24v24h-24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEB3",
    d: "M5.582 3.226h14.614a1 1 0 0 1 1 1V15.84l-4.73 4.934H5.582a1 1 0 0 1-1-1V4.226a1 1 0 0 1 1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131317",
    strokeWidth: 1.2,
    d: "M16.466 20.774H5.582a1 1 0 0 1-1-1V4.226a1 1 0 0 1 1-1h14.614a1 1 0 0 1 1 1V15.84m-4.73 4.934V16.84a1 1 0 0 1 1-1h3.73m-4.73 4.934 4.73-4.934"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M7.845 7.674h10.089M7.845 12h6.017"
  })));
};
export default SvgMenuIcSccRoad;